var ViewManager = require('../shared/app/view-manager');
var ServiceManager = require('../shared/app/service-manager'); //TODO make generic
var ScheduleManager = require('../widget/schedule-manager'); //TODO make generic
var AppointmentManager = require('../shared/app/appointment-manager');
var StaticData = require('../shared/app/static-data');
var ConfirmationFormView = require('../views/modals/confirmation-form');
var RegisterCheckinPromptModel = require('./models/modals/register-checkin-prompt');
var RegisterCheckinPromptForm = require('./views/modals/register-checkin-prompt');
var ChangePasswordModel = require('../shared/app/models/modals/change-password-form');
var ChangePasswordForm = require('./views/modals/change-password-form');
var RecoveryPasswordEmailModel = require('../shared/app/models/password-recovery/email-form');
var PasswordRecoveryFormView = require('../shared/app/views/modals/password-recovery-form');
var NavigationModel = require('../shared/app/models/navigation');
var LoginFormView = require('../shared/app/views/modals/login-form');
var CheckInLaterModalView = require('../shared/app/views/modals/checkin-later');
var CheckInLaterModel = require('../shared/app/models/modals/checkin-later');

var App = require('../abstract-app');
var WaitListView = require('./views/start-wait-list');

var MainApp = function() {};
MainApp.prototype = _.extend(App.prototype, {

  defaultRoute: 'start-booking',
  section: 'main',

  routes: {
    'waiting-list': require('./views/wait-list-appointments'),
    'wait-board': require('./views/wait-board'),
    'profile' : require('../shared/app/views/profile'),
    'login': require('../views/login'),
    'terms-of-use' : require('../shared/app/views/terms-of-use'),
    'privacy-policy' : require('../shared/app/views/privacy-policy'),
    'password-recovery' : require('../shared/app/views/password-recovery'),
    'start-booking': WaitListView,
    'start-wait-list': WaitListView,
    'store-wait-board': require('./views/store-wait-board/store-wait-board'),
    'stores-list': require('./views/stores-list/stores-list')
  },

  viewManagerView: ViewManager,
  modelNavigationModel: NavigationModel,

  initSpecific: function () {
    this.loginForm = new LoginFormView();
    this.confirmForm = new ConfirmationFormView();
    this.signupPromptForm = new RegisterCheckinPromptForm({ model: new RegisterCheckinPromptModel() });
    this.passwordRecoveryForm = new PasswordRecoveryFormView({model :  new RecoveryPasswordEmailModel()});
    this.checkInLaterModal = new CheckInLaterModalView({model: new CheckInLaterModel()});
    this.changePasswordForm = new ChangePasswordForm({model :  new ChangePasswordModel()});

    this.serviceManager = new ServiceManager();
    this.scheduleManager = new ScheduleManager();
    this.appointmentManager = new AppointmentManager();

    this.staticData = new StaticData();

    this.currentlySelectedStore = null;

  },

  /**
   * Show the login modal.
   */
  showLogin: function(message, callback) {
    if(callback) {
      this.loginForm.callback = callback;
    }
    if(message) {
      this.loginForm.message = message;
    }
    this.loginForm.show();
  },

  /**
   * Show the password recovery modal.
   */
  showRecoveryPassword: function() {
    this.passwordRecoveryForm.show();
  },

  /**
   * Show the change password modal.
   */
  showChangePassword: function(params) {
    this.changePasswordForm.model.set("successPayload", params);
    this.changePasswordForm.show();
  },

  /**
   * Show the review modal.  Takes a storeId and an int[] to specify the services being rated.
   */
  showReview: function(storeId, storeServices) {
    this.reviewForm.show(storeId, storeServices);
  },

  /**
   * Show the review modal.  Takes a storeId and an int[] to specify the services being rated.
   */
  showEmployeeReview: function(storeId) {
    this.employeeReviewForm.show(storeId);
  },

  /**
   * Show the check-in-later modal.
   */
  showCheckInLater: function(params) {
    this.checkInLaterModal.show(params);
  },


});

module.exports = MainApp;
